import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";

const Shell = styled.footer`
  padding: 4.5rem 1rem 1.25rem;
  background: #173f35;
  color: #f8f1e6;
  @media (min-width: 760px) { padding: 7rem 4vw 1.5rem; }
`;
const Top = styled.div`
  width: min(100%, 1400px); margin: auto;
  display: grid; gap: 3rem;
  @media (min-width: 760px) { grid-template-columns: 1.5fr .5fr; align-items: end; }
`;
const Claim = styled.p`
  max-width: 12ch; color: #f8f1e6; font-size: clamp(3rem, 7vw, 7rem); line-height: .88; letter-spacing: -.055em;
`;
const Nav = styled.div`display: grid; gap: .75rem; align-content: end;`;
const FooterLink = styled(NavLink)`color: #f8f1e6; font-family: Arial,sans-serif; font-size: .78rem; letter-spacing: .1em; text-transform: uppercase; &:hover{color:#d9e7a8;}`;
const External = styled.a`color: #f8f1e6; font-family: Arial,sans-serif; font-size: .78rem; letter-spacing: .1em; text-transform: uppercase; &:hover{color:#d9e7a8;}`;
const LinkWithArrow = styled.span`display:inline-flex; align-items:center; gap:.45rem;`;
const LinkArrow = styled(ArrowUpRight)`width:.88rem; height:.88rem; flex-shrink:0;`;
const Bottom = styled.div`
  width:min(100%,1400px); margin:4rem auto 0; padding-top:1rem; border-top:1px solid rgba(255,255,255,.25);
  display:flex; flex-wrap:wrap; justify-content:space-between; gap:.5rem; color:rgba(248,241,230,.62); font-family:Arial,sans-serif; font-size:.68rem; text-transform:uppercase; letter-spacing:.08em;
`;
const Footer = () => {
  const { t, i18n } = useTranslation();
  const claimFallback = i18n.language?.startsWith("ca")
    ? "Crear amb les mans. Connectar de veritat."
    : "Crear con las manos. Conectar de verdad.";
  return <Shell><Top><Claim>{t("footer.claim", { defaultValue: claimFallback })}</Claim><Nav><FooterLink to="/experiencias-ceramica-granollers"><LinkWithArrow>{t("header.reserva")}<LinkArrow aria-hidden="true" /></LinkWithArrow></FooterLink><FooterLink to="/eventos"><LinkWithArrow>{t("header.eventos")}<LinkArrow aria-hidden="true" /></LinkWithArrow></FooterLink><External href="https://www.instagram.com/eltaller.artes" target="_blank" rel="noreferrer"><LinkWithArrow>Instagram<LinkArrow aria-hidden="true" /></LinkWithArrow></External><External href="mailto:info@aguaymanto.es">info@aguaymanto.es</External></Nav></Top><Bottom><span>© {new Date().getFullYear()} El Taller de Aguaymanto</span><span>Vilanova del Vallès · Barcelona</span></Bottom></Shell>;
};
export default Footer;
